module.exports = __webpack_public_path__ + "static/media/shrunk-logo.83bf5c3e.svg";